import { createStyles } from 'antd-style';

import {
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
  hexToRgbaWithAlpha,
} from '../../theme';
import { mask } from '../../styles/mixins';
import { drawerBase } from './drawerBase';

const PADDING_TOP = ThemeSpaces.SPACE_NORM_30;

const topHeader = {
  position: 'absolute',
  top: 0,
  height: PADDING_TOP,
  display: 'flex',
  alignItems: 'center',
};

export const useShipmentDetailDrawerStyles = createStyles(({ token }) => {
  const base = drawerBase({ width: 634, token });
  return {
    shipmentDetailDrawer: {
      ...base,

      '&.wide': {
        '> .ant-drawer-content-wrapper': {
          [`@media (min-width: ${token.screenLGMin}px)`]: {
            width: '100% !important',
            paddingLeft: 390,
          },
          [`@media (min-width: ${token.screenSMMin}px) and (max-width: ${token.screenMDMax}px)`]:
            {
              width: '100% !important',
              paddingLeft: 40,
            },
          [`@media (max-width: ${token.screenXSMax}px)`]: {
            width: '320px !important',
          },
        },
      },

      '&.ant-drawer.ant-drawer-open .ant-drawer-mask': {
        animation: 'none',
        backgroundColor: 'transparent',
      },

      '&.ant-drawer-open .ant-drawer-content-wrapper': {
        boxShadow: `-4px 4px 15px ${ThemeColors.COLOR_GREY8_1}`,
      },

      '> .ant-drawer-content-wrapper': {
        ...base['> .ant-drawer-content-wrapper'],
        top: 60,
        bottom: 55,

        '> .ant-drawer-content': {
          ...base['> .ant-drawer-content-wrapper']['> .ant-drawer-content'],
          border: `2px solid ${ThemeColors.COLOR_WHITE}`,
        },

        '.ant-drawer-body': {
          ...base['> .ant-drawer-content-wrapper']['.ant-drawer-body'],
          padding: `${PADDING_TOP}px ${ThemeSpaces.SPACE_NORM_20}px ${ThemeSpaces.SPACE_NORM_20}px ${ThemeSpaces.SPACE_NORM_20}px`,
          display: 'flex',

          '> iframe': {
            width: '100%',
            alignSelf: 'stretch',
            border: 0,
          },
        },
      },
    },
    topLeftHeader: {
      ...topHeader,
      left: ThemeSpaces.SPACE_XL,

      '.red-link': {
        fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
        fontWeight: 500,
        color: ThemeColors.COLOR_RED,
        textDecoration: 'underline',
        lineHeight: 1,
      },
    },
    topRightHeader: {
      ...topHeader,
      right: ThemeSpaces.SPACE_NORM_30,
    },
    assetsInventoryDrawer: {
      '&.ant-drawer.ant-drawer-open .ant-drawer-mask': {
        ...mask(65),
        zIndex: 'initial',
        backdropFilter: 'blur(2px)',
      },

      '> .ant-drawer-content-wrapper': {
        [`@media (min-width: ${token.screenLGMin}px)`]: {
          width: '679px !important',
        },

        '> .ant-drawer-content': {
          borderWidth: 0,
          overflow: 'visible',
        },

        '.ant-drawer-close': {
          left: ThemeSpaces.SPACE_MD,
        },

        '.ant-drawer-header-title': {
          position: 'relative',
          height: 42,
          backgroundColor: ThemeColors.COLOR_WHITE,
          borderBottomWidth: 0,
          padding: 0,
          borderTopLeftRadius: token.borderRadiusLG,

          '.ant-drawer-title': {
            backgroundColor: ThemeColors.COLOR_WHITE7,
            border: `1px solid ${ThemeColors.COLOR_WHITE}`,
            height: 32,
            lineHeight: '32px',
            fontFamily: 'Roboto Condensed, sans-serif',
            fontWeight: 'bold',
            fontSize: token.fontSizeHeading4,
            textAlign: 'center',
            boxShadow: `0 4px 10px ${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY_BLUISH7_2, 0.25)}`,
            borderTopLeftRadius: token.borderRadiusLG,
          },

          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: 10,
            borderTop: `1px solid ${ThemeColors.COLOR_WHITE}`,
            borderBottom: `1px solid ${ThemeColors.COLOR_GREY8_1}`,
          },
        },

        '.ant-drawer-body': {
          border: `2px solid ${ThemeColors.COLOR_WHITE}`,
          borderTopWidth: 0,
          borderBottomLeftRadius: token.borderRadiusLG,
          overflow: 'hidden',

          [`@media (min-width: ${token.screenLGMin}px)`]: {
            padding: `${ThemeSpaces.SPACE_NORM}px ${ThemeSpaces.SPACE_NORM_20}px`,
          },
          [`@media (max-width: ${token.screenMDMax}px)`]: {
            padding: `${ThemeSpaces.SPACE_NORM}px 0`,
          },
        },
      },
    },
  };
});
